export const ACTION_CODE = 'TRAINING_ATTACHMENT' + '_ACTION';
